module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov13-cb810f70167e270386878a5797d933d2.jpg";